import { createEnvironmentVoiceAtoms } from "@t3tools/client-runtime/state/voice";

import { connectionAtomRuntime } from "../connection/runtime";

export const voiceEnvironment = createEnvironmentVoiceAtoms(connectionAtomRuntime);
